export default {
  title: 'Merksynchronisatie — Merken',
  subtitle:
    'Overzicht van alle restaurants in de groep en hun gesynchroniseerde functies. Alleen de accountbeheerder kan wijzigingen aanbrengen.',
  alert: {
    message: 'Alleen beheerderstoegang',
    description:
      'Wijzigingen in het hoofdmenu, prijzen en aanbiedingen kunnen alleen door de accountbeheerder worden gedaan. Alle locaties ontvangen automatisch updates.',
  },
  locations: {
    title: 'Locaties',
    description: 'Alle restaurants in de groep delen het hoofdmenu en de instellingen',
    locations_zero: '0 locaties',
    locations_one: '1 locatie',
    locations_other: '{{count}} locaties',
    synced: 'Gesynchroniseerd',
  },
  features: {
    title: 'Gesynchroniseerde functies',
    description: 'Deze functies worden beheerd door de hoofdinstellingen',
    menus: {
      title: 'Hoofdmenu',
      desription: 'Menu-items, categorieën en beschrijvingen worden gesynchroniseerd voor alle locaties',
    },
    smart_pricing: {
      title: 'Slimme prijsstelling',
      desription: 'Prijsregels en aanpassingen worden gesynchroniseerd voor alle locaties',
    },
    offers: {
      title: 'Aanbiedingen & promoties',
      desription: 'Actieve aanbiedingen, kortingen en promoties worden gesynchroniseerd voor alle locaties',
    },
  },
};
